
import React from 'react';
import { Button } from '@/components/ui/button';

const CryptoInvestmentSection = () => {
  return (
    <section 
      className="py-16 md:py-24 bg-cover bg-center relative"
      style={{ 
        backgroundImage: 'url("/lovable-uploads/8fd428fa-f195-4a5e-80cf-c91c67964095.png")',
        backgroundColor: '#1b1420',
        backgroundBlendMode: 'overlay',
      }}
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="header-invest-wrapper mx-auto max-w-4xl">
          <div className="left-header-invest-wrapper">
            <h1 className="is-heading-l is-txt-white is-txt-align-center-t text-3xl md:text-4xl lg:text-5xl font-semibold text-white text-center mb-6">
              Investir en crypto, <span className="is-txt-gradient bg-clip-text text-transparent bg-gradient-to-r from-orange-400 to-orange-600">sans effort.</span>
            </h1>
            
            <div className="is-txt-color-grey100 is-txt-align-center-t text-gray-300 text-center mb-8 max-w-2xl mx-auto">
              Constituez votre portefeuille avec une collection croissante de crypto-monnaies, automatisez votre stratégie d'investissement et gérez vos actifs à partir d'un seul endroit.
            </div>
            
            <div className="text-center mb-12">
              <a 
                href="https://qxtk.adj.st/invest?adj_t=qhb6ybm&adj_campaign=websiteinvestcrypto&adj_adgroup=CTA&adj_fallback=https%3A%2F%2Fapp.finary.com%2Fv2%2Fsignup&adj_redirect_macos=https%3A%2F%2Fapp.finary.com%2Fv2%2Fsignup" 
                target="_blank" 
                className="button-primary-orange w-button inline-flex items-center justify-center px-6 py-3 bg-orange-500 hover:bg-orange-600 transition-colors text-white rounded-md font-medium"
              >
                Découvrir
              </a>
            </div>
            
            <div className="reassurrance-cards-wrapper flex flex-col md:flex-row justify-center gap-8 max-w-3xl mx-auto">
              <div className="reassurance-card flex flex-col items-center p-4 bg-black/40 backdrop-blur-md rounded-lg border border-white/10">
                <img 
                  src="https://wf-cache.finary.com/64fb4d9ac1d7723434b54019/64ff7c26bd7c3a70c63f3287_features.svg" 
                  loading="lazy" 
                  alt="a computer screen with a shield on it" 
                  className="picto3-3 w-12 h-12 mb-3"
                />
                <div className="is-txt-white is-txt-xxsmall is-txt-align-center text-white text-center text-sm">
                  Pas de frais cachés<br/>100% transparent
                </div>
              </div>
              
              <div className="reassurance-card flex flex-col items-center p-4 bg-black/40 backdrop-blur-md rounded-lg border border-white/10">
                <img 
                  src="https://wf-cache.finary.com/64fb4d9ac1d7723434b54019/64ff7c2658e85415eb568204_stars.svg" 
                  loading="lazy" 
                  alt="stars" 
                  className="stars-card-reassurance w-12 h-12 mb-3"
                />
                <div className="is-txt-white is-txt-xxsmall is-txt-align-center text-white text-center text-sm">
                  500 000+ utilisateurs<br/>Noté 4,7 | + de 5000 avis
                </div>
              </div>
              
              <div className="reassurance-card flex flex-col items-center p-4 bg-black/40 backdrop-blur-md rounded-lg border border-white/10">
                <img 
                  src="https://wf-cache.finary.com/64fb4d9ac1d7723434b54019/64ff7c262fe67af0291c8961_monnaie.svg" 
                  loading="lazy" 
                  alt="coin" 
                  className="picto3-3 w-12 h-12 mb-3"
                />
                <div className="is-txt-white is-txt-xxsmall is-txt-align-center text-white text-center text-sm">
                  Diversifiez votre patrimoine<br/>avec le Web3 et la blockchain
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CryptoInvestmentSection;
